/**
 * Normalizes a region/state code by removing the 'us' prefix if present
 * @param region The region/state code to normalize
 * @returns The normalized region code
 */
export const normalizeRegion = (region?: string): string => {
    if (!region) return "";
    return region.toUpperCase().replace(/^US/, "");
};

/**
 * Checks if a region matches a state restriction
 * @param region The user's current region
 * @param stateRestriction The state restriction to check against
 * @returns boolean indicating if the region matches the restriction
 */
export const isRegionRestricted = (
    region?: string | null,
    country?: string | null,
    stateRestriction?: string[] | null
): boolean => {
    if (
        !region ||
        !country ||
        country.toUpperCase() !== "US" ||
        !stateRestriction
    )
        return false;

    return stateRestriction.some(
        (restriction) =>
            normalizeRegion(restriction) === normalizeRegion(region)
    );
};

export const isUnknownState = (
    region?: string | null,
    country?: string | null
): boolean => {
    return (
        !!country &&
        country.toUpperCase() === "US" &&
        (!region || region === "")
    );
};
